import React from "react";
import {
  HiArrowRight,
  HiMiniExclamationTriangle,
  HiSparkles,
} from "react-icons/hi2";
import { PiPlanetFill } from "react-icons/pi";

const KeepPromoBubble = ({ promo }) => {
  if (!promo) return null;

  return (
    <div className="speechPromo">
      <span className="speechBall" aria-hidden="true" />

      <div className="speechMascot" aria-hidden="true">
        <span className="speechPlanet">
          <PiPlanetFill />
        </span>
        <span className="speechSparkle">
          <HiSparkles />
        </span>
      </div>

      <div className="speechCopy">
        <div className="speechEyebrow">EAGLES PARK PICKUP</div>
        <div className="speechTitle">{promo.title}</div>
        <div className="speechDesc">{promo.desc}</div>
      </div>
    </div>
  );
};

const FindWarningPanel = ({ warning }) => {
  if (!warning) return null;

  return (
    <div className="warningPanel">
      <div className="warningIcon" aria-hidden="true">
        <HiMiniExclamationTriangle />
      </div>

      <div className="warningCopy">
        <div className="warningPill">주의</div>
        <div className="warningTitle">{warning.title}</div>
        <div className="warningDesc">{warning.desc}</div>
      </div>
    </div>
  );
};

const ActionCard = ({ item, onClick }) => {
  const Icon = item.Icon;

  return (
    <div
      className={`actionCard ${item.name} ${item.disabled ? "disabled" : ""}`}
      onClick={() => onClick(item)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick(item);
      }}
      role="button"
      tabIndex={0}
      aria-disabled={item.disabled ? "true" : "false"}
    >
      <div className="ribbon" aria-hidden="true" />

      <div className="cardInner">
        <div className="cardTop">
          <div className="emojiBubble" aria-hidden="true">
            <span className="emojiIcon">
              <Icon />
            </span>
            <span className="bubbleHighlight" />
          </div>

          <div className="text">
            <div className={`guideBadge ${item.name}`}>{item.badge}</div>
            <div className="title">{item.title}</div>
            <div className="sub">{item.sub}</div>
            <div className="helperText">{item.helper}</div>
          </div>

          <div className="ctaRow" aria-hidden="true">
            <div className="cta">
              <span>{item.ctaLabel || "시작"}</span>
              <span className="ctaArrow">
                <HiArrowRight />
              </span>
            </div>
          </div>
        </div>

        <div className="cardBottom">
          <div className="meta">{item.desc}</div>
          <KeepPromoBubble promo={item.promo} />
          <FindWarningPanel warning={item.warning} />
        </div>

        {item.disabled && <div className="chip">준비중</div>}
      </div>
    </div>
  );
};

export default ActionCard;
